import { render, staticRenderFns } from "./ReversedReportTable.vue?vue&type=template&id=6456df2c&"
import script from "./ReversedReportTable.vue?vue&type=script&lang=js&"
export * from "./ReversedReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports